import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SectionLabel } from '../ui/SectionLabel';

const values = [
  {
    title: 'Excellence',
    desc: 'We uphold the highest standards in cuisine, service, and presentation.'
  },
  {
    title: 'Integrity',
    desc: 'We act with honesty, professionalism, and respect in all relationships.'
  },
  {
    title: 'Hospitality',
    desc: 'We create genuine connections that turn dining into a memorable experience.'
  },
  {
    title: 'Innovation',
    desc: 'We embrace creativity to enhance both guest satisfaction and operational success.'
  },
  {
    title: 'Teamwork',
    desc: 'We build a culture of collaboration and mutual respect across all levels.'
  },
  {
    title: 'Sustainability',
    desc: 'We commit to mindful practices that support our community and environment.'
  }
];

export const CoreValues = () => (
  <section className="py-24 md:py-32 bg-ivory border-y border-gold/10">
    <div className="container mx-auto px-6 md:px-14">
      <FadeIn className="text-center mb-20">
        <SectionLabel>Our Principles</SectionLabel>
        <h2 className="font-serif text-4xl md:text-5xl text-charcoal">Core Values</h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
        {values.map((v, i) => (
          <FadeIn key={v.title} delay={i * 0.1} direction="up">
            <div className="group text-center">
              <h3 className="font-serif text-xl text-wine mb-4 flex items-center justify-center gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-gold/40" />
                {v.title}
                <span className="w-1.5 h-1.5 rounded-full bg-gold/40" />
              </h3>
              <p className="text-charcoal/60 font-light text-sm leading-relaxed max-w-xs mx-auto">
                {v.desc}
              </p>
              <div className="mt-6 w-8 h-px bg-gold/20 mx-auto group-hover:w-16 group-hover:bg-gold/60 transition-all duration-500" />
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);